import React, { useEffect, useState } from 'react'
import * as s from './styles'
import Icon from '../../icon'

export type Subitem = {
  id: string
  icon?: string
  text?: string
  event?: () => void
  customContent?: JSX.Element
}

type Props = {
  subitems?: Subitem[]
}

const Submenu: React.FC<any> = (props: Props): JSX.Element => {
  const [open, setOpen] = useState<boolean>()
  const [toggle, setToggle] = useState<boolean>(false)

  useEffect(() => {
    setOpen
  }, [toggle])

  return (
    <s.Submenu onClick={() => setToggle(!toggle)}>
      {props.subitems?.map((subitem, key) =>
        subitem.customContent ? (
          <s.Subitem key={key}>{subitem.customContent}</s.Subitem>
        ) : (
          <s.Subitem key={key}>
            <s.ActionLink onClick={subitem.event}>
              <Icon name={subitem.icon} />
              <s.Text> {subitem.text} </s.Text>
            </s.ActionLink>
          </s.Subitem>
        ),
      )}
    </s.Submenu>
  )
}

export default Submenu
